<!--
<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            ÁLBUMES DE AUTÓGRAFOS <br>
           <br>           
        </p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio26/maria-alvarado">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio26/maria-alvarado">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio26/maria-alvarado">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio27/ALBUMES-000.jpg">
</section>
-->
<div class="fondoBlanco_Intro">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 5%;"
                            class="fontMS700 text-center colorPrincipal  font-40">
                            ÁLBUMES DE AUTÓGRAFOS
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                            <br>
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: -8%;" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                            <br>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                <a style="color: black;">
                    <!-- <a [routerLink]="['/visor/FOT-54869']" target="_blank" style="color: black;"> -->
                    <img width="100%" src="/assets/images/micrositio/micrositio27/ALBUMES-000.jpg">
                </a>
                <p class="fontMS500Italic text-justify text-right font-15">
                    <br>
                    Carátula interna del álbum de autógrafos de José Octavio de Oyague (1878). <br>
                    Dibujo a tinta y colores. 25.8 x 18.2 cm. Reproducido en: Álbumes de autógrafos / Estudio y selección de Jhon Delgado Galván. – <br>
                    Lima: Biblioteca Nacional del Perú, 2023. – p. 55. Ubicación: ME-O 366 (Fondo Antiguo)<br>
                    <br>
                </p>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="text-justify font-24">
                            <span class="fontMS500 font-26">C</span>onscientes de su valor no solo como fuente de estudio de las diferentes expresiones de la cultura material de la humanidad sino, 
                            también, como documento artístico, se presenta esta selección de imágenes presentes en los álbumes de autógrafos (álbumes de amistades o de recuerdos) 
                            conservados en los repositorios de la Biblioteca Nacional del Perú (BNP). En estos álbumes, los propietarios coleccionaron las firmas 
                            autógrafas de personas de su círculo social, las que se presentan en forma de dedicatorias, poemas, dibujos y otras composiciones. 
                            
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoVerde_BB">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2 bott">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-bottom: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal  font-38">
                            LOS ÁLBUMES DE AUTÓGRAFOS
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec_Izq bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" style="margin-top: 2%;" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    <div class="col-sm-1"></div>

                    <div class="col-sm-1"></div>
                        <div class="col-sm-10">
                            <p class="fontMS100 text-justify font-24">
                                <br>
                                <span class="fontMS500 font-26">E</span>l álbum fue utilizado por las élites peruanas entre mediados del siglo XIX y mediados del siglo XX. 
                                La referencia más antigua sobre la aparición del álbum en el Perú es de 1838. En estos álbumes, 
                                propietarios como Felipe Pardo y Aliaga, Juana Manuela Gorriti, Clorinda Matto de Turner, Miguelina Acosta, 
                                Elvira García y García, Angélica Palma y Martín Chambi, coleccionaron las firmas autógrafas de personas 
                                de su círculo amical o de su interés, las que se presentan en forma de dedicatorias, poemas, obras artísticas 
                                y otras composiciones. De esta forma, el álbum se convirtió en una marca de distinción o prestigio dependiendo 
                                de los nombres que formaban parte de sus páginas.
                                <br><br>
                                Las más recientes investigaciones señalan que el álbum permitió que las mujeres acentuaran sus prácticas lectoras y escriturales. 
                                <br><br>
                            </p>

                            <img  style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #148d8d" width="100%" src="/assets/images/micrositio/micrositio27/ALBUMES-001.jpg">
                            <p class="fontMS100Italic text-justify text-right font-15" style="color:#465a65">
                                <br>
                                Dedicatoria de Francisco de Paula González Vigil en el álbum de autógrafos de Juana Manuela Gorriti. Lima, 1 de enero de 1853.<br>
                                González Vigil fue Director de la Biblioteca Nacional del Perú entre 1836 a 1838, y de 1845 a 1875.<br>
                                Ubicación: D-2394 (Colección General de Manuscritos)<br>
                                <br>
                            </p>
    
                            <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #148d8d" width="100%" src="/assets/images/micrositio/micrositio27/ALBUMES-004.jpg">
                            <p class="fontMS100Italic text-justify text-right font-15" style="color:#465a65">
                                <br>
                                Dedicatoria de Luis Benjamín Cisneros en el álbum de autógrafos de Juana Rosa de Amézaga. 1886.<br>
                                Ubicación: D-8166 (Colección General de Manuscritos)<br>
                                <br>
                            </p>
                        </div>
                    <div class="col-sm-1"></div>
                </div>
                
            <div class="row" >
                <div class="col-sm-6">
                    <img  width="100%" src="/assets/images/micrositio/micrositio27/ALBUMES-002.png">
                    <p class="fontMS100Italic  text-left font-15 " style="color:#465a65">
                        <br>
                        Cubierta del álbum de autógrafos de Jesús Diez Canseco. <br>
                        Encuadernación en tapas blandas y cubiertas de cuero. <br>
                        Título impreso con tipografía dorada y gofrada. 12.9 x 16.2 cm.<br>
                        Ubicación: E-8 (Colección General de Manuscritos)<br>
                        <br>
                    </p>
                </div>
                <div class="col-sm-5 text-right">
                    <img  class="img_Img" src="/assets/images/micrositio/micrositio27/ALBUMES-003.jpg">
                    <p class="fontMS100Italic text-right font-15" style="color:#465a65">
                        <br>
                        Cubierta del álbum de Teresa Blondet Goicochea.<br>
                        Encuadernación en tapas blandas y cubiertas de cuero. Título <br>
                        impreso con tipografía dorada y gofrada. 15.8 x 20 cm. <br>
                        Ubicación: 1000061978 (Colección Cisneros Sánchez) <br>                 
                        <br>
                    </p>
                </div>
                <div class="col-sm-1"></div>
            </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-004.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 colorPrincipal2 text-center font-40">
                            ÁLBUM DE AUTÓGRAFOS<br>
                            DE JUANA MANUELA GORRITI
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-004.png">
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-004.png">
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="text-justify text-white fontMS100 font-24">
                            <br><br>
                            <span class="fontMS500 font-26">E</span>l álbum de la escritora Juana Manuela Gorriti (Salta, Argentina, ca. 1816-Buenos Aires, 
                            Argentina, 1892) es el más antiguo que custodia la BNP.<br>
                            El álbum contiene composiciones entre 1849 y 1864, muchas de ellas de los asistentes a sus tertulias literarias. Entre ellos, destacan Ricardo Palma, 
                            Carlos Augusto Salaverry, Clemente Althaus y Luis Benjamín Cisneros.<br><br>
                            Este álbum destaca no solo por sus textos, sino también por las anotaciones que añadió Ricardo Palma. 
                            <br>
                        </p>
                        <div class="row p-3">
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79574" target="_blank" style="color: black;">
                                    <img style="border: 10px solid #ffffff; width: 98%;" src="/assets/images/micrositio/micrositio27/ALBUMES-005.jpg">
                                </a>
                                <p class="text-right text-white fontMS100Italic font-15">
                                    <br>
                                    [Retrato de Francisco de Paula Gonzales Vigil (1852) y dedicatoria (1853)].<br>
                                    Dibujo a lápiz sobre papel gofrado, 14 x 10.9 cm.<br>
                                    Retrato de Francisco de Paula González Vigil (1792-1875), clérigo, político e intelectual peruano. 
                                    Dibujo anónimo obsequiado por su amigo Francisco Gómez. Acompaña al dibujo la siguiente dedicatoria: «Tengo mucha satisfacción, al poner mi nombre en el Álbum de la muy apreciable Sra. Doña J. Manuela Gorriti, correspondiendo a su deseo».
                                    <br>Lima, 1 de enero de 1853.
                                    Ubicación: D-2394 (Colección General de Manuscritos)
                                    <br>
                                </p>
                                <br>
                                <div style="background:#ffffff">
                                    <a href="http://hdl.handle.net/20.500.14428/79580 " target="_blank" style="color: black;">
                                        <img style="border: 10px solid #ffffff; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-007.jpg">
                                    </a>
                                    <p class="text-right fontMS100Italic font-15 p-3">
                                        [Frontispicio] (s.f.). <br>
                                        Dibujo a lápiz, 27.8 x 21.5 cm.<br>
                                        Anónimo.<br>
                                        Ubicación: D-2394 (Colección<br> General de Manuscritos)
                                        <br>
                                    </p>
                                </div>
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/79582 " target="_blank" style="color: black;">
                                    <img style="border: 10px solid #ffffff; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-009.jpg">
                                </a>
                                <p class="text-right text-white fontMS100Italic font-15">
                                    <br>
                                    Bodegón, (s.f.). <br>
                                    Lápiz y acuarela, 11.1 x 7.8 cm. <br>
                                    Anónimo.<br>
                                    Ubicación: D-2394 (Colección General de Manuscritos)
                                    <br>
                                </p>
                                <br>
                                <div style="background:#ffffff">
                                    <a href="http://hdl.handle.net/20.500.14428/79589" target="_blank" style="color: black;">
                                        <img style="border: 10px solid #ffffff; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-011.jpg">
                                    </a>
                                    
                                    <p class="text-right fontMS100Italic font-15 p-3">
                                        [Sin título] (s.f.) <br>
                                        Calcografía iluminada, 16.6 x 12.2 cm. <br>
                                        Anónimo. <br>
                                        La imagen se encuentra acompañada con la siguiente <br>
                                        dedicatoria: «Esta figura me parece que debe <br>
                                        asemejarse algo a el alma de una virgen o de un poeta, <br>
                                        cuando, después de la vida, se introduce en el Paraíso». <br>M. [rúbrica]<br>
                                        Ricardo Palma señala que la autógrafa es del poeta José<br> 
                                        Arnaldo Márquez (1832-1903).<br>
                                        Ubicación: D-2394 (Colección General de Manuscritos)
                                        <br>
                                    </p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79575 " target="_blank" style="color: black;">
                                    <img style="border: 10px solid #ffffff; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-006.jpg">
                                </a>
                                <p class="text-right text-white fontMS100Italic font-15">
                                    <br>
                                    [Retrato de Juana Manuela Gorriti] (1862/1864).<br>
                                    Dibujo a lápiz, 27.6 x 21.4 cm. <br>
                                    Dedicado por Modesto Molina (1844-1925), destacado poeta, periodista y político tacneño. Participó en la defensa de Tacna y colaboró en el ejército como director del Boletín de Guerra.
                                    Ubicación: D-2394 (Colección General de Manuscritos)
                                    <br>
                                </p>
                                <br><br>
                                <div style="background:#ffffff">
                                    <a href="http://hdl.handle.net/20.500.14428/79581 " target="_blank" style="color: black;">
                                        <img style="border: 10px solid #ffffff; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-008.jpg">
                                    </a>
                                    <p class="text-right fontMS100Italic font-15 p-3">
                                        «Baños Cauquenes-Chile» (s.f.). <br>
                                        Dibujo a lápiz, 21.7 x 27.7 cm.<br>
                                        Dedicado por Giovatto Molinelli<br> (1810-?), 
                                        pintor costumbrista y <br>paisajista genovés. Estuvo en Chile<br> 
                                        entre 1858 a 1861 (Museo Nacional <br>de Bellas Artes, s.f.).<br>
                                        Ubicación: D-2394 (Colección <br>General de Manuscritos)
                                        <br>
                                    </p>
                                </div>
                                <br><br><br>
                                <a href="http://hdl.handle.net/20.500.14428/79588" target="_blank" style="color: black;">
                                    <img style="border: 10px solid #ffffff; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-010.jpg">
                                </a>
                                <p class="text-right text-white fontMS100Italic font-15">
                                    <br>
                                    «Doña Clara acaricia a Anjélica» (1854).<br>
                                    Litografía iluminada, 9.5 x 6 cm. <br>
                                    Con esta ilustración Ricardo Palma acompaña el texto <br>
                                    «Infernum el hechicero (Tradición peruana)».<br>
                                    Ubicación: D-2394 (Colección General de Manuscritos)
                                    <br>
                                </p>
                                <br>
                                <div style="background:#ffffff">
                                    <a href="http://hdl.handle.net/20.500.14428/79590 " target="_blank" style="color: black;">
                                        <img style="border: 10px solid #ffffff; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-012.jpg">
                                    </a>
                                    <p class="text-right fontMS100Italic font-15 p-3">
                                        [Alegoría a la República] (s.f.).<br>
                                        Dibujo a tinta, 12.4 x 8.3 cm.<br>
                                        Anónimo.<br>
                                        Ubicación: D-2394 (Colección General de Manuscritos)
                                        <br><br><br><br><br><br><br>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoVerdeO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-002.png" width="100%">
                
                <div class="row ">
                    <div class="col-sm-12">
                        <img src="/assets/images/micrositio/micrositio27/ALBUMES-CITA-000.png" width="5%">
                        <div style="margin-left: 4%;">
                            <p class="text-center text-white fontMS100Italic font-24 mb-0" > 
                                <span>
                                    En el Perú, al igual que en otros países de Latinoamérica, 
                                    el álbum se popularizó entre los grupos de la de la élite social e intelectual. 
                                    Esto se debió a diversos factores; uno de ellos fue que el álbum se convirtió 
                                    en un medio para afirmar y exponer su prestigio. Las personas buscaban obtener 
                                    álbumes de la mejor calidad material y conseguir autógrafos de personajes ilustres 
                                    de la sociedad, siendo los escritores y artistas los más apreciados y requeridos, 
                                    convirtiendo a este bien en parte de su cultura material
                                </span>
                            </p>
                            <div class="text-right p-0">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-CITA-001.png" width="3%">
                            </div>
                        </div>
                        <p class=" fontMS100Italic text-white font-24 text-center">
                            <span>
                                (Álbumes de autógrafos. Jhon Delgado. 2023)
                            </span>
                            <br>
                        </p>
                    
                    </div>
                    
                </div>
                
                <img src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-002.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-2">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 colorPrincipal text-center font-40">
                            ÁLBUM DE AUTÓGRAFOS DE <br>
                            JOSÉ OCTAVIO DE OYAGUE
                        </p>
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-003.png">
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="text-justify fontMS100 font-24">
                            <br><br>
                            <span class="fontMS500 font-26">E</span>l álbum de José Octavio de 
                            Oyague (ca. 1850-19-?) es el de más grandes dimensiones que custodia 
                            la BNP y se encuentra en buen estado de conservación, siendo visualmente 
                            muy llamativo por las ilustraciones que contiene. <br><br>
                            Es notable por su muestra de interés en el coleccionismo de monogramas y escudos, una afición peculiar y poco difundida en el Perú.
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                        <div class="row p-5">
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79583" target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #148d8d; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-013.jpg">
                                </a>
                                <p class="text-right fontMS100Italic font-15">
                                    <br>
                                    [Monogramas] (s.f.) <br>
                                    Impresos iluminados en alto y bajo relieve, 22.6 x 30 cm.<br>
                                    Ubicación: ME-O 366 <br>
                                    (Fondo Antiguo)
                                    <br>
                                </p>
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/79585 " target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #148d8d; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-015.jpg">
                                </a>
                                    <p class="text-right fontMS100Italic font-15 p-3">
                                        «Huáscar» (s. f.) <br>
                                        Óleo sobre cartulina, 22.7 x 30 cm.<br>
                                        Firmado por F. C.<br>
                                        Ubicación: ME-O 366 (Fondo Antiguo)<br>
                                        <br>
                                    </p>
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/79591 " target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #148d8d; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-017.jpg">
                                </a>
                                <p class="text-right fontMS100Italic font-15">
                                    <br>
                                    [Retrato] (s.f.) <br>
                                    Dibujo a tinta, 30 x 22.7 cm.<br>
                                    Dedicado por Antonio Robles (ca. 1836-1922), artista, escultor, <br>
                                    dibujante y calígrafo. Destacado docente de la segunda mitad <br>
                                    del siglo XIX, sirvió como profesor en el colegio Guadalupe <br>
                                    (Variedades, 5 de junio de 1915).<br>
                                    Ubicación: ME-O 366 (Fondo Antiguo)                                    
                                    <br>
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79584 " target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #148d8d; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-014.jpg">
                                </a>
                                <p class="text-right fontMS100Italic font-15">
                                    <br>
                                    [Monogramas y Escudos] (s.f.).<br>
                                    Impresos en alto y bajo relieve, 22.6 x 30 cm.<br>
                                    Ubicación: ME-O 366 (Fondo Antiguo)<br>
                                    <br>
                                </p>
                                <br><br>
                                <a href="http://hdl.handle.net/20.500.14428/79586" target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #148d8d; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-016.jpg">
                                </a>
                                    <p class="text-right fontMS100Italic font-15 p-3">
                                        [Paisaje y barco] (s.f.) <br>
                                        Acuarela sobre cartulina, 22.7 x 30 cm.<br>
                                        Anónimo. <br>
                                        Ubicación: ME-O 366 (Fondo Antiguo)<br>
                                        <br><br><br><br>
                                    </p>
                                <br><br><br>
                                <a href="http://hdl.handle.net/20.500.14428/79592 " target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #148d8d; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-018.jpg">
                                </a>
                                <p class="text-right fontMS100Italic font-15">
                                    <br>
                                    Monograma de José Octavio de Oyague (s.f.) <br>
                                    Dibujo a tinta y colores, 30 x 22.7 cm.<br>
                                    Firmado por Beteta. Ubicación: ME-O 366 (Fondo Antiguo)

                                    <br>
                                </p>
                            </div>
                        </div>
            </div>
        </div>
    </div>
</div>
<div class="fondoAzulO2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-002.png" width="100%">
                <div class="row ">
                    <div class="col-sm-12 p-5">
                        <img src="/assets/images/micrositio/micrositio27/ALBUMES-CITA-000.png" width="5%">
                        <div style="margin-left: 4%; margin-right: 4%;">
                            <p class="text-right text-white fontMS100Italic font-24 mb-0" > 
                                <span>
                                    En este proceso, el álbum se convirtió en uno de los primeros medios 
                                    donde las mujeres comenzaron a desarrollar ejercicios literarios y artísticos. 
                                    Varias mujeres ilustradas del Perú del siglo XIX tuvieron su propio álbum de 
                                    autógrafos, por lo que las acciones realizadas para nutrir estos álbumes 
                                    contribuyeron [a] su madurez intelectual
                                </span>
                            </p>
                            
                        </div>
                        <div class="text-right p-0">
                            <img src="/assets/images/micrositio/micrositio27/ALBUMES-CITA-001.png" width="3%">
                        </div>
                        <div style="margin-left: 4%; margin-right: 4%;">
                        <p class=" fontMS100Italic text-white font-24 text-right">
                            <span>
                                (Álbumes de autógrafos. Jhon Delgado. 2023)
                            </span>
                            <br>
                        </p>
                        </div>
                    </div>
                    
                </div>
                
                <img src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-002.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>
<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-3">
                        <img class="LineSubsec" width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-005.png">
                    </div>
                    <div class="col-sm-7">
                        <p style="line-height: 120%;margin-bottom: 0%;"
                            class="fontMS700 colorPrincipal2 text-center font-40">
                            ÁLBUM DE AUTÓGRAFOS DE <br>
                            JUANA ROSA DE AMÉZAGA
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                <div class="c100">
                    <img class="lineCel" style="margin-top: 0%;" width="100%"
                        src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-005.png">
                </div>

                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="text-justify fontMS100 font-24">
                            <br><br>
                            <span class="fontMS500 font-26">E</span>l álbum de la escritora Juana 
                            Rosa de Amézaga (Lima, 1853-1904)  contiene poemas y pensamientos de 
                            reconocidos personajes de las letras peruanas, que pueden ubicarse entre 
                            1885 y 1904: Ricardo Palma, Luis Benjamín Cisneros, Lastenia Larriva de 
                            Llona,  Amalia Puga de Losada, Carlos Germán Amézaga, Clorinda Matto de 
                            Turner, entre otros. <br><br>
                            El álbum contiene dos arreglos de flores secas que le fueron obsequiados 
                            como recuerdos. 
                        </p>
                    </div>
                    <div class="col-sm-1"></div>
                </div>

                        <div class="row p-5">
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79569" target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #3dce32; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-019.jpg">
                                </a>
                                <p class="text-left fontMS100Italic font-15">
                                    <br>
                                    [Cupido y Venus] (18-?).<br>
                                    Óleo sobre cartulina y papel dorado, 14.3 x 20.9 cm.<br>
                                    Dedicado por María Eugenia Rosas y de la Puente (ca. <br>
                                    1864-1949), presidenta de la Unión Católica del Perú. Esposa del
                                    político y diplomático peruano Melitón F. Porras. <br>
                                    En 1886, el afamado escritor, poeta y diplomático peruano Luis 
                                    Benjamín Cisneros (1837-1904) se refirió a la pintura con el 
                                    siguiente poema: «Declaro que causa horror / ver, aunque solo 
                                    en pintura, / un cupido trovador/ que está cantando al amor/ a 
                                    Venus en miniatura».<br>
                                    Ubicación: D-8166 (Colección General de Manuscritos)
                                    <br>
                                </p>
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/79571" target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #3dce32; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-021.jpg">
                                </a>
                                    <p class="text-left fontMS100Italic font-15 p-3">
                                        <br>
                                        Monograma de Juana Rosa de Amézaga (1896). <br>
                                        Litografía iluminada, 20.8 x 13.9 cm.<br>
                                        Dedicado por Enrique Jiménez Góngora, pintor, dibujante, <br>
                                        litógrafo, grabador e ingeniero moqueguano, colaborador en El <br>
                                        Perú Ilustrado y otras revistas.<br>
                                        Ubicación: D-8166 (Colección General de Manuscritos)
                                        <br>
                                    </p>
                                <br>
                                <a href="http://hdl.handle.net/20.500.14428/79283" target="_blank">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #3dce32; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-023.jpg">
                                </a>
                                <p class="text-left fontMS100Italic font-15">
                                    <br>
                                    [Barco] (s.f.) <br>
                                    Dibujo a lápiz, 10.2 x 16.5 cm. <br>
                                    Anónimo.   <br>          
                                    Ubicación: D-8166 (Colección General de Manuscritos)      
                                    <br>
                                </p>
                            </div>
                            <div class="col-sm-6">
                                <a href="http://hdl.handle.net/20.500.14428/79570" target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #3dce32; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-020.jpg">
                                </a>
                                <p class="text-left fontMS100Italic font-15">
                                    <br>
                                    «Achan apedreado» (1886).<br>
                                    Óleo sobre cartulina, 18.5 x 13.5 cm.<br>
                                    Firmado por F. Arrese. Probablemente corresponde a Felipe Arrese<br>
                                    Beitia (1841-1906), poeta y escultor vasco.
                                    Ubicación: D-8166 (Colección General de Manuscritos)
                                    <br><br><br>
                                </p>
                                <br><br>
                                <a href="http://hdl.handle.net/20.500.14428/79572" target="_blank" style="color: black;">
                                    <img style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #3dce32; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-022.jpg">
                                </a>
                                    <p class="text-left fontMS100Italic font-15 p-3">
                                        [Paisaje] (1887).<br>
                                        Témpera sobre cartulina, 7.5 x 12 cm.<br>
                                        Dedicado por Daniel Ezequiel Cuevas (1857-?), pintor peruano, hijo <br>
                                        de José Manuel Cuevas, primer grabador de la Casa de la Moneda <br>
                                        de Lima. Fue discípulo de Leonardo Barbiere, Federico Torrico y <br>
                                        Romeo Gayo. Tuvo su propio estudio en Lima en donde contó con <br>
                                        numerosos alumnos.
                                        Ubicación: D-8166 (Colección General de Manuscritos)
                                        <br><br><br>
                                    </p>
                                <br><br><br>
                                <a href="http://hdl.handle.net/20.500.14428/79573" target="_blank" style="color: black;">
                                    <img href="" style="border: 8px solid #ffffff; border-width: 3px 3px 3px 3px; outline: 8px solid #3dce32; width: 100%;" src="/assets/images/micrositio/micrositio27/ALBUMES-024.jpg">
                                </a>
                                <p class="text-left fontMS100Italic font-15">
                                    <br>
                                    [Recuerdo] (1887).<br>
                                    Ramo de flores secas y cinta de tela, 20.8 x 13.8 cm.<br>
                                    Anónimo.<br>
                                    Ubicación: D-8166 (Colección General de Manuscritos)
                                    
                                </p>
                            </div>
                        </div>

            </div>
        </div>
    </div>
</div>

<div class="fondoVerdeO2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-002.png" width="100%">
                
                <div class="row ">
                    <div class="col-sm-11">
                        <img src="/assets/images/micrositio/micrositio27/ALBUMES-CITA-000.png" width="5%">
                        <div style="margin-left: 4%;">
                            <p class="text-justify text-white fontMS100Italic font-24 mb-0" > 
                                <span>
                                    Además, es importante considerar si el álbum pudo servir como un medio para 
                                    que los intelectuales y artistas expandieran y fortalecieran su círculo social 
                                    en los grupos académicos. Alguien que recibía un álbum sabía que su composición 
                                    estaría expuesta a la crítica de las siguientes personas que lo tuvieran, por 
                                    lo que el álbum podría entenderse como un objeto para buscar aprobación y recomendación 
                                    en el campo de las letras y el arte
                                </span>
                            </p>
                            <div class="text-right p-0">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-CITA-001.png" width="3%">
                            </div>
                        </div>
                        <p class=" fontMS100Italic text-white font-24 text-center">
                            <span>
                                (Álbumes de autógrafos. Jhon Delgado. 2023)
                            </span>
                            <br>
                        </p>
                    
                    </div>
                    <div class="col-sm-1"></div>
                </div>
                
                <img src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-002.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>

<div class="fondoVerde">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-1">
                        <img src="\assets\images\micrositio\micrositio27\ALBUMES-025.png" >
                    </div>
                    <div class="col-sm-2"></div>
                    <div class="col-sm-5">
                        <p style="line-height: 100%;margin-bottom: 0%;" class="fontMS300Italic text-white font-26 text-right">
                            <br><br><br><br>
                            PREGUNTAS PARA REFLEXIONAR
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-1 " style="width: 2%">
                        <p class="text-white text-justify font-24">
                        1. <br>
                    </p>
                    </div>
                    <div class="col-sm-11">
                        <p class="text-white text-justify font-24">
                            ¿En qué medida el  álbum nos permite reconsiderar la predominancia de la letra en los 
                           estudios de la cultura de los siglos XIX y XX?
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-1 " style="width: 2%">
                        <p class="text-white text-justify font-24">
                        2. <br>
                    </p>
                    </div>
                    <div class="col-sm-11">
                        <p class="text-white text-justify font-24">
                            ¿Por qué las obras plásticas o las composiciones contenidas en los álbumes son 
                            consideradas como ejercicios intelectuales menores?
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-1 " style="width: 2%">
                        <p class="text-white text-justify font-24">
                        3. <br>
                    </p>
                    </div>
                    <div class="col-sm-11">
                        <p class="text-white text-justify font-24">
                            ¿Cuenta con un álbum de autógrafos o de otra índole? ¿Por qué lo conserva?
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
                <div class="row">
                    <div class="col-sm-12">
                        <img width="100%"
                            src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-001.png">
                    <br><br>
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center font-40" style="color: #465a65">
                            PARA SABER MÁS
                        </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-10">
                        <p class="fontMS500 font-24" style="color: #465a65">
                            
                            BIBLIOGRAFÍA
                            <br><br>
                        </p>                        
                        <div class="row" style="color: #465a65">
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24">
                                Delgado, J. (2023). Álbumes de autógrafos. Estudio y selección de Jhon Delgado. 
                                Lima: Biblioteca Nacional del Perú
                            </p>
                            </div>
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24 " style="word-wrap: break-word;">
                                Miseres, V. (2018). Solicitudes de amistad: el uso del álbum como red de 
                                sociabilidad y práctica de escritura femenina. Arizona Journal of Hispanic 
                                Cultural Studies, Vol. 22, pp. 9-27. 
                                <a href="https://muse.jhu.edu/article/726446" target="_blank"> https://muse.jhu.edu/article/726446</a>
                            </p>
                            </div>
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24" style="word-wrap: break-word;">
                                Paez, C. (21 de diciembre de 2014). Cuando el álbum estaba de moda. La Gaceta.
                                <a href="https://www.lagaceta.com.ar/nota/620946/sociedad/cuando-album-estaba-moda.html" target="_blank"> 
                                     https://www.lagaceta.com.ar/nota/620946/sociedad/cuando-album-estaba-moda.html
                                    </a>
                            </p>
                            </div>
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24">
                                Pachas, S. (2008). Las artistas plásticas de Lima, 1891-1918. [Tesis de Magister].
                                Lima: Universidad Nacional Mayor de San Marcos.
                            </p>
                            </div>
                            <div class="col-sm-1" style="width: 7%">
                                <img src="/assets/images/micrositio/micrositio27/ALBUMES-026.png">
                            </div>
                            <div class="col-sm-11">
                                <p class="fontMS500 font-24">
                                Sotomayor, E. (2022). Las nuevas lectoras del siglo XIX, género,
                                libro y lecturas de la primera generación de ilustradas peruanas. 
                                Lima: Biblioteca Nacional del Perú.
                                <br><br>
                            </p>
                            </div>
                        </div>    
                    </div>
                    <div class="col-sm-1"></div>
            
            <div class="row">
                <div class="col-sm-12">
                    <img  width="100%"
                        src="/assets/images/micrositio/micrositio27/ALBUMES-LINEA-001.png">
                </div>
            </div>
    </div>
</div>